module.exports = __webpack_public_path__ + "static/media/logo_green.2b1a2864.png";